<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Rapporten</h2>
                <p>Klik op 'Downloaden' om het betreffende rapport te downloaden.</p>

                <table class="table table-hover" width="100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                        <th scope="col">Rapport</th>
                        <th scope="col">Datum</th>
                        <th scope="col">&nbsp;</th>
                    </tr>
                    </thead>
                    <tr v-for="report in object.reports" :key="report.id">
                        <td>{{ report.name }}</td>
                        <td>{{ report.created_at | formatDate }}</td>
                        <td><a href="#" class="btn" @click.prevent="downloadReport(report)">Downloaden</a></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
	import moment from 'moment-timezone'

	export default {
		props: ['object'],

		data () {
			return {
				isLoading: false,
			}
		},

		mounted () {
			console.log(this.object)
		},

		filters: {
			formatDate (value) {
				return moment(value).format('LLLL')
			},
		},

		methods: {
			handleClosePopup () {
				this.$emit('togglePopup')
			},

			downloadReport (report) {
				window.axios({
					url: process.env.VUE_APP_API_URL + '/reports/' + report.id,
					method: 'GET',
					responseType: 'arraybuffer',
				}).then((response) => {
					let blob = new Blob([response.data], { type: 'application/pdf' })

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob)
						return
					}

					let data = window.URL.createObjectURL(blob)
					let link = document.createElement('a')

					link.href = data
					link.download = report.name
					link.click()

					setTimeout(function () {
						window.URL.revokeObjectURL(data)
					}, 100)
				})
			},
		},
	}
</script>